import { module } from 'modujs';


import Swiper from "swiper";
import {Navigation,Pagination,EffectFade,Autoplay} from "swiper/modules";

export default class extends module {
    constructor(m) {
        super(m);
        const swiper = new Swiper( this.$( 'swiper' )[0] , {
            modules: [EffectFade,Navigation,Pagination,Autoplay],
            effect: "fade",
            speed: 500,
            loop: true,
            navigation: {
                prevEl: this.$( 'prev-button' )[0],
                nextEl: this.$( 'next-button' )[0],
            },
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            pagination: {
                el: this.$( 'swiper-pagination' )[0],
                clickable: true,
            },

        });
    }
    init() {}
    destroy(){}
}
